import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { ReactElement } from 'react'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import Grid from 'components/Grid'
import Header from 'components/Header'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const modules: { [key: string]: ReactElement } = {
    grid: <Grid titleText={properties?.titleText} colorMode={colorMode} />,
    header: (
      <Header
        titleText={properties?.titleText}
        leadText={properties?.leadText}
        caption={'Video: Rick Ray/Videvo'}
        authors={
          properties && properties?.authors
            ? JSON.parse('[' + properties?.authors + ']')
            : undefined
        }
        publishDate={properties?.publishDate}
      />
    ),
  }
  return (
    <AppContainer
      isHeader={properties?.module === 'header'}
      $colorMode={colorMode}
    >
      {' '}
      {properties && <>{modules[properties.module]}</>}
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ isHeader: boolean }>`${GlobalVariables}
  //hacky stuff for positioning the header
  z-index: ${(prop) => (prop.isHeader ? 99999 : 1)};
  position: relative;
  top: ${(prop) => (prop.isHeader ? '-16px' : 0)};
  @media (min-width: 1931px) {
    margin: ${(prop) => (prop.isHeader ? '0 -25%' : 'unset')};
  }
  @media only screen and (max-width: 1024px) {
    padding: ${(prop) => (prop.isHeader ? '0' : '0 2rem')};
  }

  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

export default MainComponent
